export const CHAT_WIDGET_METRIC_NAME_SPACE = "chat-widget";
export const DEFAULT_WIDGET_TYPE = "CustomChatWidget";

export const getLdasEndpointUrl = (region) => {
    return `https://ieluqbvv.telemetry.connect.${region}.amazonaws.com/prod`;
};